<template>
  <div id="pushDetail">
    <div class="tableContainer">
      <el-card class="box-card">
        <div class="tableBox">
          <div class="orangeIcon">
            <i class="el-icon-s-order"></i>
          </div>
        </div>
        <div style="margin-top: 20px">
          <p>推文名称: {{ pushName }}</p>
          <el-table
            :data="tableData"
            style="width: 100%; margin-top: 20px">
            <el-table-column
              prop="materialPic"
              :label="$t('materialUseStatistics.materialPic')"
            >
              <template slot-scope="scope">
                <img class="materialPic" :src="scope.row.materialPic" alt="">
              </template>
            </el-table-column>
            <el-table-column
              prop="isInLibrary"
              :label="$t('materialUseStatistics.isInLibrary')"
              :formatter="isInLibraryFormatter"
            >
            </el-table-column>
            <el-table-column
              prop="libraryWatermark"
              :label="$t('materialUseStatistics.libraryWatermark')"
              width="240">
            </el-table-column>
            <el-table-column
              prop="manualReview"
              :label="$t('materialUseStatistics.manualReview')"
            >
              <template slot-scope="scope">
                否
                <el-switch style="margin: 0 4px 4px 4px" v-model="scope.row.manualReview"></el-switch>
                是
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              :label="$t('materialUseStatistics.remark')"
              width="380">
              <template slot-scope="scope">
                <el-input v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <footer>
            <el-button type="success" @click="save()">
              {{ $t('save') }}
            </el-button>
            <el-button type="success" @click="close()">
              {{ $t('close') }}
            </el-button>
          </footer>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Cookies from 'js-cookie'
export default {
  name: 'PushDetail',
  components: {
  },
  data: function () {
    return {
      pushName: this.$route.query.pushName || null,
      id: this.$route.query.id || null,
      dialogTableVisible: false,
      initFilterForm: {
        timeScope: '', // 时间段
      },
      doorName: this.$route.query.doorName || null,
      filterForm: {},
      tableData: [],
    }
  },
  mounted () {
    this.getList()
  },
  computed: {
  },
  methods: {
    close: function () {
      window.close()
    },
    save: async function () {
      // todo: 保存
      console.log('save', this.tableData)
    },
    getList: async function () {
      // todo: 获取列表
      this.tableData = [
        {
          materialPic: '',
          isInLibrary: true,
          libraryWatermark: 'kids summer outing looks',
          manualReview: true,
          remark: '备注'
        }
      ]
    },
    isInLibraryFormatter(row){ //素材是否来自素材库
      switch (row.isInLibrary) {
        case true:
          return "是"
          break;
        case false:
          return "否"
          break;
        default:
          return "未知"
          break;
      }
    },
  }
}
</script>

<style lang="sass" scoped>
  a
    margin-left: 10px
  .filterConditionContainer
    margin: 40px 20px 20px 20px
  .tableContainer
    margin: 40px 20px
  input[type=file]
    display: none
  .materialPic
    width: 50px
    height: 50px
  footer
    padding-top: 20px
    text-align: center

</style>



// WEBPACK FOOTER //
// src/pages/wo/pushDetail.vue